import { addError } from 'monitor';

import { autoDownloadBlob } from '../autoDownloadBlob/autoDownloadBlob';

export const downloadImageFromUrl = async (url: string, fileName?: string): Promise<void> => {
  try {
    const response = await fetch(url);
    const blob = await response.blob();
    const defaultFileName = fileName || url.split('/').pop() || 'download.jpg';
    await autoDownloadBlob(blob, defaultFileName);
  } catch (error) {
    addError(error);
    window.open(url, '_blank');
  }
};
